

































import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "ban-user-component",
})
export default class BanUserComponent extends Vue {
  accept(): void {
    this.$router.push("/quickstart").catch(() => {});
    window.location.reload();
  }
  isHawkings(): boolean {
    if (window.location.host.includes("hawkings.education")) return true;
    else return false;
  }
}
